/*
    node_js
    3/5/2021 6:13 AM
    by Oleksandr
*/

import CWP from "./cwp/CWP";
import DemoMsgWindow from "./cwp/graphics/windows/modalWindows/DemoMsgWindow";
import ATG from "./atg/ATG";
import {useContext, useEffect, useRef, useState} from "react";
import {CwpContext} from "../contexts/CwpContext";

const DEMO = () => {
    const [isDemoMsgWindowVisible, setIsDemoMsgWindowVisible] =useState(true);



    return (
        <>
            <CWP isDemo={true} setIsDemoMsgWindowVisible={setIsDemoMsgWindowVisible}/>
            <ATG isPlt={true}/>
            {isDemoMsgWindowVisible && <DemoMsgWindow />}
        </>
    )
}

export default DEMO;